module.exports = __webpack_public_path__ + "img/marshall-island.172c13d4.png";